<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t("customization_table.media_project.title") }}
        </h3>
      </div>

      <div class="box-body">
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{
                $t("customization_table.media_project.project_name")
              }}</label>
              <input
                class="form-control"
                v-model="media_project.project_name"
                :placeholder="
                  $t('customization_table.media_project.project_name')
                "
              />
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="">{{
                $t("customization_table.media_project.page_size")
              }}</label>
              <input
                type="number"
                class="form-control"
                v-model="media_project.page_size"
                :placeholder="$t('customization_table.media_project.page_size')"
              />
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="">{{
                $t("customization_table.media_project.description")
              }}</label>
              <input
                class="form-control"
                v-model="media_project.description"
                :placeholder="
                  $t('customization_table.media_project.description')
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          v-if="has_perm('update_project_setting') || GET_ACCOUNT_DATA.id == 1"
          @click="onSave_MEDIA_Project()"
          style="margin-right: 5px;"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{ $t("common.save") }}
        </button>
      </div>
    </div>
    <loading :active.sync="is_loading" :can-cancel="false" color="#1E90FF">
    </loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';

export default {
  name: "CustomizationTable_Media",
  data() {
    return {
      media_project: {
        project_name: "",
        page_size: null,
        description: ""
      },
      is_loading: false
    };
  },
  watch: {
    GET_MEDIA_PROJECT_DATA: function() {
      this.media_project.project_name = this.GET_MEDIA_PROJECT_DATA.name;
      this.media_project.page_size = this.GET_MEDIA_PROJECT_DATA.pagination;
      this.media_project.description = this.GET_MEDIA_PROJECT_DATA.description;
    }
  },
  computed: {
    ...mapGetters([
      "GET_MEDIA_PROJECT_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_MEDIA_PROJECT",
      "PUSH_MEDIA_PROJECT"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onSave_MEDIA_Project: function() {
      if (this.media_project.page_size <= 0) {
        this.ON_SHOW_TOAST({
          message: "Page size not validate",
          styleType: "danger"
        });
      } else {
        let data = {
          project_name: utils.getCleanStringValue(this.media_project.project_name),
          page_size: this.media_project.page_size,
          description: utils.getCleanStringValue(this.media_project.description)
        };
        this.PUSH_MEDIA_PROJECT(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
              this.getMediaProject();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    getMediaProject: function() {
      this.is_loading = true;
      this.GET_MEDIA_PROJECT().then(
        function(res) {
          this.is_loading = false;
        }.bind(this)
      ).catch(
        function(error) {
          this.is_loading = false;
        }.bind(this)
      );
    }
  },
  mounted() {
    this.GET_MEDIA_PROJECT();
  },
  components: {
    loading: Loading
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/views/Project/ProjectMediaSettings.vue